<template>
<div>
    <div class="btn-group text-center">
          <button class="btn btn-primary btn-hide" style="width: 80px" v-if="!showSearch" v-on:click="toggleSearch">
            <i class="fa fa-search" style="font-size: 16px"></i>
          </button>
          <button class="btn btn-default btn-hide" style="width: 80px" v-if="showSearch" v-on:click="toggleSearch">
            Hide
          </button>
        </div>

        <div v-if="showSearch">
          <div class="checkbox">
            <label>
              <input type="checkbox" v-on:change="depthLevel" />
              Complex Search
            </label>
          </div>
          <vue-query-builder :rules="rules" :maxDepth="depth" :labels="labels" :styled="true" v-model="query"></vue-query-builder>

          <div>
            <label for="pageSelect" style="width: 120px; margin-bottom: 15px">Records per page</label>
            <select class="form-control record-number" :value="limit" id="pageSelect" v-on:change="changeLimit">
              <option>25</option>
              <option>50</option>
              <option>100</option>
              <option>250</option>
              <option>500</option>
            </select>
          </div>
          <div>
            <label for="pageNum" style="width: 120px">Page Number</label>
            <input type="number" :value="offset" min="1" v-on:change="changePage" class="form-control page-select" placeholder="Page #" id="pageNum" />
          </div>
           <div style="display: block; margin-top: 20px">
            <div class="btn-group text-center">
              <button class="btn btn-default btn-hide btn-share" v-on:click="doFormatUrl">
                Share Url
              </button>
               <button class="btn btn-primary btn-hide btn-search" v-on:click="doSearch">
                Search
                <i class="fa fa-search"></i>
              </button>
            </div>
          </div>
          <hr />
        </div>
     </div>

</template>
<script>
import VueQueryBuilder from "vue-query-builder";
export default {
  name: "QueryBuilder",
  components:{
      VueQueryBuilder
        },
    props: ["rules", "getFilteredData",  "labels"],
    methods: {
      toggleSearch() {
       this.showSearch = !this.showSearch;
      },  
      changeLimit() {
        this.limit = event.target.value;
        this.getFilteredData();
      },
      depthLevel() {
        this.depth = this.depth === 3 ? 1 : 3;
      },
      changePage() {
        this.offset = event.target.value;
        this.getFilteredData();
      },
      doSearch() {
       this.getFilteredData();
      },
      doFormatUrl() {
      const query = {};
      query.where = this.query;
      query.table = this.table;
      query.limit = this.limit;
      query.offset = this.offset;

      let filterUrl;
      if (this.query === null) {
        filterUrl = `${window.location.href.split("?")[0]}`;
      } else {
        filterUrl = `${window.location.href.split("?")[0]}?${encodeURIComponent(JSON.stringify(query))}`;
      }

      let textArea = document.createElement("textarea");
      textArea.value = filterUrl;
      document.body.appendChild(textArea);
      textArea.select();

      try {
        document.execCommand("copy");
        window.alert("Shareable URL copied to clipboard");
      } catch (err) {
        //empty
      }
      document.body.removeChild(textArea);
      },
    },
    data: function() {
    return {
      showSearch: false,
      limit: 25,
      offset: 1,
      depth: 1,
      query: null
     
    }

  } 
}
</script>
<style scoped>
.page-select,
.record-number {
  width: 75px;
  display: inline-block;
  margin-left: 5px;
  margin-right: 5px;
}

.btn {
  margin-top: 30px;
  margin-bottom: 20px;
}

.btn-default {
  margin-right: 10px;
}

.btn-hide {
  margin-right: 0px;
  margin-bottom: 10px;
  margin-top: 0px;
}

.btn-share,
.btn-search {
  margin-bottom: 2px;
  width: 125px;
}

.submit-btn {
  width: 30%;
}

.checkbox {
  margin-top: 0px;
}

h3 {
  margin-bottom: 20px;
}
label {
  padding-top: 5px;
}

.table-name {
  text-align: left;
}
.container-fluid {
  margin-right: 3%;
  margin-left: 5%;
}
.show-search {
  margin-top: 0;
  margin-bottom: 0;
}
</style>